import React from "react";

import dayjs from "dayjs";

import {CircularProgress, Option, Select, Stack} from "@mui/joy";
import {Swiper, SwiperSlide} from 'swiper/react';
import Card from "@mui/joy/Card";
import Divider from "@mui/joy/Divider";
import Chip from "@mui/joy/Chip";
import Typography from "@mui/joy/Typography";

// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import OpportunityCard from "../Cards/OpportunityCard";
import SliceVerticalCard from "../Slice/SliceVerticalCard";
import {customRange, getWeekNumber, getWeekRange} from "../../utils/misc";
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";
import OpportunityEvaluationCard from "./OpportunityEvaluationCard";


class OpportunitiesEvaluation extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            opportunities: null,
            slices: null,
            operators: null,
            ready: false,
            year: (new Date()).getFullYear(),
        };
        this.swipers = []
    }

    async componentDidMount() {
        await this.retrieveReport();
    }

    async retrieveReport() {
        this.setState({ready: false});
        const api = new BaseApi();
        const year = this.state.year;

        const oppResponse = await api.get('opportunity/', {
            work_started: true,
            work_ended: false,
            page_size: 10000,
        });
        const opportunities = oppResponse.data.results;

        const slicePromises = opportunities.map(op =>
            api.get('slice', {
                opportunity: op.id,
                year,
                page_size: 10000,
                ordering: 'id',
            })
        );
        const sliceResponses = await Promise.all(slicePromises);

        const slices = {};
        const operators = {};

        opportunities.forEach((op, index) => {
            const results = sliceResponses[index].data.results;
            const sliceOperators = {};

            results.forEach(slice => {
                const key = slice.operator.id + slice.role;
                operators[key] = slice.operator;
                sliceOperators[key] = {...(sliceOperators[key] || {}), [slice.week]: slice};
            });

            slices[op.id] = {};
            Object.entries(sliceOperators).forEach(([key, weeks]) => {
                slices[op.id][key] = customRange(1, 52, 1).map(week => weeks[week] || null);
            });
        });

        this.setState({opportunities, slices, operators, ready: true});
    }

    // async retrieveReport(){
    //     this.setState(
    //         {
    //             ready: false,
    //         }
    //     );
    //     let url = `opportunity/`;
    //     const api = new BaseApi();
    //     let params = {
    //         work_started: true,
    //         work_ended: false,
    //         page_size: 10000,
    //     };
    //     let response = await api.get(
    //         url,
    //         params,
    //     );
    //     let opportunities = response.data.results
    //
    //     let slices = {}
    //     let operators = {}
    //
    //     for (const opportunity of opportunities){
    //         let url = 'slice';
    //         let params = {
    //             opportunity: opportunity.id,
    //             year: this.state.year,
    //             page_size: 10000,
    //             ordering: 'id',
    //         }
    //         let response = await api.get(url, params);
    //         let sliceOperators = {}
    //         for (let slice of response.data.results){
    //             operators[slice.operator.id + slice.role] = slice.operator
    //             if (sliceOperators[slice.operator.id + slice.role]){
    //                 sliceOperators[slice.operator.id + slice.role][slice.week] = slice
    //             }
    //             else {
    //                 sliceOperators[slice.operator.id + slice.role] = {}
    //                 sliceOperators[slice.operator.id + slice.role][slice.week] = slice
    //             }
    //         }
    //         slices[opportunity.id] = {}
    //         for (const sliceOperator of Object.entries(sliceOperators)){
    //             slices[opportunity.id][sliceOperator[0]] = customRange(1, 52, 1).map((r) => {
    //                 return sliceOperator[1][r]?sliceOperator[1][r]:null
    //             })
    //         }
    //     }
    //     this.setState(
    //         {
    //             opportunities: opportunities,
    //             slices: slices,
    //             operators: operators,
    //             ready: true,
    //         }
    //     );
    // }

    render() {
        let currentYear = new Date().getFullYear();
        if (!this.state.ready) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                spacing={2}
            >
                <Select
                    defaultValue={this.state.year}
                    onChange={(event, newValue) => {
                        this.setState({
                            year: parseInt(newValue)
                        }, this.retrieveReport.bind(this))
                    }}
                >
                    <Option value={currentYear - 1}>{currentYear - 1}</Option>
                    <Option value={currentYear}>{currentYear}</Option>
                    <Option value={currentYear + 1}>{currentYear + 1}</Option>
                </Select>
                <Stack
                    direction='row'
                    spacing={1}
                    sx={{
                        width: '100%',
                        position: 'sticky',
                        top: 10,
                        zIndex: 1001,
                    }}
                >
                    <Stack
                        direction={'row'}
                        sx={{
                            width: '20%'
                        }}
                        spacing={1}
                    >
                        <Card
                            size={'sm'}
                            variant={'soft'}
                            sx={{
                                width: '50%'
                            }}
                        >
                            <Typography
                                level={'body-sm'}
                            >
                                Сделка
                            </Typography>
                        </Card>
                        <Card
                            size={'sm'}
                            variant={'soft'}
                            sx={{
                                width: '50%'
                            }}
                        >
                            <Stack
                                direction='row'
                                spacing={1}
                                sx={{
                                    width: '100%'
                                }}
                            >
                                <Typography
                                    level={'body-sm'}
                                >
                                    Автор
                                </Typography>
                                <Stack
                                    direction='row'
                                    spacing={1}
                                >
                                    <Chip
                                        color={'primary'}
                                        size={'sm'}
                                        onClick={() => {
                                            for (let swiper of this.swipers){
                                                swiper.slidePrev()
                                            }
                                        }}
                                    >
                                        {'<'}
                                    </Chip>
                                    <Chip
                                        color={'primary'}
                                        size={'sm'}
                                        onClick={() => {
                                            for (let swiper of this.swipers){
                                                swiper.slideNext()
                                            }
                                        }}
                                    >
                                        >
                                    </Chip>
                                </Stack>
                            </Stack>
                        </Card>
                    </Stack>
                    <Swiper
                        style={{
                            width: '80%',
                        }}
                        grabCursor={false}
                        spaceBetween={6}
                        onSwiper={(swiper) => {
                            swiper.slideTo(getWeekNumber(new Date()) - 5 > 0?getWeekNumber(new Date()) - 5:0)
                            this.swipers.push(swiper)
                        }}
                        allowTouchMove={false}
                        breakpoints={{
                            1550: {
                                slidesPerView: 6
                            },
                            1180: {
                                slidesPerView: 4
                            },
                            1020: {
                                slidesPerView: 3
                            },
                            700: {
                                slidesPerView: 2
                            }
                        }}
                    >
                        {customRange(1, 52, 1).map((r) => {
                            const { start, end } = getWeekRange(r, this.state.year);
                            return (
                                <SwiperSlide
                                    key={`WeekCard-${r}`}
                                >
                                    <Card
                                        variant={'soft'}
                                        size={'sm'}
                                    >

                                        <Stack
                                            direction={'row'}
                                            sx={{
                                                alignItems: "center",
                                            }}
                                            spacing={1}
                                        >
                                            <Chip
                                                size={'sm'}
                                                color={'primary'}
                                            >
                                                {r}
                                            </Chip>
                                            <Typography
                                                level={'body-sm'}
                                            >
                                                {dayjs(start).format('DD.MM.YYYY')} - {dayjs(end).format('DD.MM.YYYY')}
                                            </Typography>
                                        </Stack>
                                    </Card>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </Stack>
                {
                    this.state.opportunities.map((o) => (
                        <>
                            <Stack
                                direction='row'
                                spacing={1}
                            >
                                <Stack
                                    spacing={1}
                                    sx={{
                                        width: '10%'
                                    }}
                                >
                                    <OpportunityCard
                                        color={'primary'}
                                        mini={true}
                                        opportunityID={o.id}
                                        width={'100%'}
                                    />
                                    <OpportunityEvaluationCard
                                        opportunity={o}
                                    />
                                </Stack>
                                <Stack
                                    spacing={1}
                                    sx={{
                                        width: '90%'
                                    }}
                                >
                                    {
                                        this.state.slices[o.id]?Object.entries(this.state.slices[o.id]).map((op) => (
                                            <Stack
                                                direction='row'
                                                spacing={1}
                                                sx={{
                                                    width: '100%'
                                                }}
                                            >
                                                <Stack
                                                    sx={{
                                                        width: '11.1%',
                                                        ml: 1
                                                    }}
                                                >
                                                    <ProfileHorizontalByProps
                                                        user={this.state.operators[op[0]].user}
                                                    />
                                                </Stack>
                                                <Swiper
                                                    style={{
                                                        width: '88.9%',
                                                    }}
                                                    spaceBetween={6}
                                                    grabCursor={false}
                                                    onSwiper={(swiper) => {
                                                        swiper.slideTo(getWeekNumber(new Date()) - 5 > 0?getWeekNumber(new Date()) - 5:0)
                                                        this.swipers.push(swiper)
                                                    }}
                                                    allowTouchMove={false}
                                                    breakpoints={{
                                                        1550: {
                                                            slidesPerView: 6
                                                        },
                                                        1180: {
                                                            slidesPerView: 4
                                                        },
                                                        1020: {
                                                            slidesPerView: 3
                                                        },
                                                        700: {
                                                            slidesPerView: 2
                                                        }
                                                    }}
                                                >
                                                    {op[1].map((s) => {
                                                        if (s){
                                                            return (
                                                                <SwiperSlide
                                                                    // key={`SliceCard-${i}-${op[0]}-${o[0]}`}
                                                                >
                                                                    <SliceVerticalCard
                                                                        slice={s}
                                                                        variant={'soft'}
                                                                    />
                                                                </SwiperSlide>
                                                            )
                                                        }
                                                        return (
                                                            <SwiperSlide
                                                                // key={`SliceCard-${i}-${op[0]}-${o[0]}`}
                                                            >
                                                                <Card
                                                                    variant={'soft'}
                                                                    sx={{
                                                                       height:  '80%'
                                                                    }}
                                                                >

                                                                </Card>
                                                            </SwiperSlide>
                                                        )
                                                    })}
                                                </Swiper>
                                            </Stack>
                                        )):null
                                    }
                                </Stack>
                            </Stack>
                            <Divider />
                        </>
                        ))
                    }
                </Stack>
        );
    }
}

export default OpportunitiesEvaluation
